<template>
	<div class="mdyIntroduceCo">
		<div class="firstBoxMdy">
			<img class="mFirst" src="../../assets/dymanticLanshu/jijinghuiTopNewlist.jpg">
			<div class="mFirstBox">
				<div class="mFirstBoxImgBox" @click="open">
					<img class="mFirstBoxImg" src="../../assets/mImg/whiteMenu.png" alt="">
				</div>
			</div>
		</div>

		<el-drawer class="drawerBox" :visible.sync="drawer" :direction="direction" :before-close="handleClose"
			unique-opened>
			<el-menu :default-active="this.$route.path" class="el-menu-vertical-demo" @open="handleOpen"
				@close="handleCloseMenu" router>
				<el-menu-item index="/m">
					<i class="el-icon-s-home"></i>
					<span slot="title">首页</span>
				</el-menu-item>
				<el-menu-item index="/maboutLansu">
					<i class="el-icon-document"></i>
					<span slot="title">关于我们</span>
				</el-menu-item>
				<el-menu-item index="/mbrandLansu">
					<i class="el-icon-data-analysis"></i>
					<span slot="title">美业菩提</span>
				</el-menu-item>
				<el-submenu index="4">
					<template slot="title">
						<i class="el-icon-star-off"></i>
						<span>菩提基金会</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="/mdyIntroduce">基金会介绍</el-menu-item>
						<el-menu-item index="/mdyNews">基金会新闻</el-menu-item>
						<el-menu-item index="/mdyjoinus">联系我们</el-menu-item>
					</el-menu-item-group>
				</el-submenu>
				<el-submenu index="5">
					<template slot="title">
						<i class="el-icon-trophy"></i>
						<span>兰树品牌</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="/mhuaibrand">淮树</el-menu-item>
						<el-menu-item index="/mxinbrand">心清堂</el-menu-item>
						<el-menu-item index="/mshuibrand">水姻缘</el-menu-item>
						<el-menu-item index="/myibrand">一清堂</el-menu-item>
						<!-- <el-menu-item index="/mzhongbrand"><span>Dr.CHUNG<span style="vertical-align: super;">+</span></span></el-menu-item> -->
						<el-menu-item index="/mlanshuBrand">兰树</el-menu-item>
						<el-menu-item index="/mzbqfBrand">植本清方</el-menu-item>
					</el-menu-item-group>
				</el-submenu>
				<el-menu-item index="/mTrends">
					<i class="el-icon-bell"></i>
					<span slot="title">兰树动态</span>
				</el-menu-item>
			</el-menu>

		</el-drawer>

		<div class="breadBox">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/m' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>菩提基金会</el-breadcrumb-item>
				<el-breadcrumb-item>基金会介绍</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="breadLine"></div>

		<div class="firstBox">
			<div class="firstBoxTop firstBoxTop2">菩提基金会由来</div>
			<div class="firstBoxTitleBox">
				据中国出生缺陷监测网的数据统计，手足畸形的发病率近有千分之一。在常见的手足畸形中，又以拇指为多。而由于手部功能的精细性，手部畸形的矫正具有“难度大、费用高、需多次手术”的特点，而这是许多贫困家庭难以承受的，也导致很多患病儿童没有得到及时有效的治疗。
			</div>
			<div class="firstBoxTitleBox2">
				为了帮助他们得到更好的救助和治疗，兰树企业特此成立了杭州兰树菩提慈善基金会。
			</div>
		</div>

		<div class="firstBox">
			<div class="firstBoxTop firstBoxTop2">菩提基金会简介</div>
			<div class="firstBoxTitleBox">
				杭州兰树菩提慈善基金会是由兰树化妆品股份有限公司发起，在浙江省民政局注册成立的非公募基金会。基金会成立于2019年7月，注册资金200万元。
			</div>
			<div class="firstBoxTitleBox2">
				自成立以来，基金会秉承“爱是正大无私的奉献”的精神，聚焦教育支持、扶贫济困、儿童发展和灾害救助等领域，以“高效、专业，创新”的工作理念，“诚信、透明”的工作态度，接受政府及公众的监督。
			</div>
			<div class="firstBoxTitleBox3">
				菩提基金会积极探索可持续发展的公益模式，注重经济效益与社会效益的平衡发展，努力实现企业与社会的共赢局面。
			</div>
		</div>

		<div class="firstBox">
			<div class="firstBoxTop2">菩提基金会宗旨</div>
			<div class="zongzhiImgBox">
				<img class="zongzhiImg" src="../../assets/dymanticLanshu/jijinhui01.jpg" alt="">
			</div>
			<div class="firstBoxTitleBox">立足公益、面向社会，关注医疗、教育、民生等问题，关心困难群体，聚集多方公益慈善力量，积极开展助医、助学、助困项目。</div>

		</div>

		<div class="firstBox">
			<div class="firstBoxTop2">菩提基金会愿景</div>
			<div class="zongzhiImgBox">
				<img class="zongzhiImg" src="../../assets/dymanticLanshu/jijinhui02.jpg" alt="">
			</div>
			<div class="firstBoxTitleBox">通过公益反哺社会，让公益成为一项可持续发展事业。</div>
		</div>

		<div class="firstBox">
			<div class="firstBoxTop2">菩提基金会使命</div>
			<div class="zongzhiImgBox">
				<img class="zongzhiImg" src="../../assets/dymanticLanshu/jijinhui03.jpg" alt="">
			</div>
			<div class="firstBoxTitleBox">助学扶贫 助医扶弱 成就他人 善行天下</div>
		</div>

		<div class="footerBoxMain">
			<div class="footerFirstLine">
				<li class="footerItem"><a target="_blank"
						href="https://huaishu.tmall.com/shop/view_shop.htm?spm=a230r.7195193.1997079397.2.124378dduXIhiW">淮树旗舰店</a>
				</li>
				<li class="footerItem"><a target="_blank"
						href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">心清堂官方企业店</a>
				</li>
				<li class="footerItem"><a target="_blank" href="https://shop349169226.taobao.com/?spm=a21xtw.29978516.0.0">水姻缘旗舰店</a></li>
			</div>
			<div class="footerSecondLine">
				<li class="footerItem"><a target="_blank"
						href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">一清堂官方企业店</a>
				</li>
				<li class="footerItem"><a target="_blank" href="https://drchung.tmall.com" ><span>Dr.CHUNG<span style="vertical-align: super;">+</span></span>旗舰店</a></li>
				<li class="footerItem"><a target="_blank" href="https://zhibenqingfang.tmall.com">植本清方旗舰店</a></li>
				<li class="footerItem"><a target="_blank" href="https://zhibenqingfang.tmall.com">植本清方旗舰店</a></li>
				<div class="lastHeader">
					<li>
						<router-link to="/maboutLansu" tag="a">登录</router-link>
					</li>
					|
					<li>
						<router-link to="/m" tag="a">注册</router-link>
					</li>
				</div>
			</div>
			<div class="footerBoxHeader">
				<div class="footerBoxHeaderLeft">
					<img class="codeImg" src="../../assets/code.png" alt="">
					<span class="codeText">兰树公众号</span>
				</div>
				<div class="footerBoxHeaderRight">
					<img class="codeImg" src="../../assets/xcxNew.jpg" alt="">
					<span class="codeText">兰树云小程序</span>
				</div>
			</div>
			<div class="footerInfoBox">
				<div class="emailBox">邮箱: lasur@lasur.com</div>
				<div class="phoneBox">电话: 0571-89025888</div>
				<div class="addressBox">地址: 浙江省杭州市之江东路越秀·维多利中心A座 17楼</div>
			</div>
			<div class="footerLine"></div>
			<div class="footerBoxBottom">
				<div class="footerLeft">
					Copyright © 2023 兰树化妆品股份有限公司
				</div>
				<div class="footerLeft">
					<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a><br />
					<img
						src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2022-09-13_13-29-23_21054.png" /><a
						target="_blank"
						href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740">浙公网安备
						33052102000740号</a>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
export default {
	data() {
		return {
			drawer: false,
			direction: 'ltr'
		}
	},
	methods: {
		handleClose(done) {
			done()
		},
		open() {
			this.drawer = true
		},
		handleOpen(key, keyPath) {
			console.log(key, keyPath);
		},
		handleCloseMenu(key, keyPath) {
			console.log(key, keyPath);
		}
	}
}
</script>

<style scoped>
.mdyIntroduceCo {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.mFirst {
	width: 100%;
}

.mFirstBox {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 99;
}


.mFirstBoxImgBox {
	width: 100%;
	margin-top: 0.5rem;
}

.mFirstBoxImg {
	width: 50%;
	float: left;
	position: relative;
	left: 0.5rem;
}

.firstBoxMdy {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}


.breadBox {
	display: flex;
	margin-top: 1rem;
}

.breadLine {
	width: 100%;
	height: 1px;
	background-color: #E8E8E8;
	margin-top: 1rem;
}

.firstBox {
	display: flex;
	flex-direction: column;
	width: 90%;
	margin: 0 auto;
}

.firstBoxTop {
	text-align: left;
	padding-left: 0.5em;
	border-left: 4px #0F3F93 solid;
	font-size: 1.2rem;
	font-family: MicrosoftYaHei;
	color: #111111;
	line-height: 18px;
}

.firstBoxTop2 {
	text-align: left;
	padding-left: 0.5em;
	border-left: 4px #0F3F93 solid;
	font-size: 1.2rem;
	font-family: MicrosoftYaHei;
	color: #111111;
	line-height: 18px;
	margin-top: 2rem;
}

.firstBoxTitleBox {
	width: 90%;
	margin: 0 auto;
	color: #333333;
	font-size: 1rem;
	line-height: 1.5625rem;
	margin-top: 1rem;
}

.firstBoxTitleBox2 {
	width: 90%;
	margin: 0 auto;
	color: #333333;
	font-size: 1rem;
	line-height: 1.5625rem;
	margin-top: 0.5rem;
}

.firstBoxTitleBox3 {
	width: 90%;
	margin: 0 auto;
	color: #333333;
	font-size: 1rem;
	line-height: 1.5625rem;
	margin-top: 0.5rem;
}

.zongzhiImgBox {
	width: 90%;
	margin: 0 auto;
	margin-top: 1rem;
}

.zongzhiImg {
	width: 100%;
}

.footerBoxMain {
	width: 100%;
	min-height: 620px;
	background-color: #F9F9F9;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 2rem;
}

.footerFirstLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 auto;
	justify-content: center;
	margin-top: 1rem;
}

.footerSecondLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 auto;
	justify-content: center;
	margin-top: 0.5rem;
}

.footerItem {
	list-style: none;
}

.footerItem a {
	color: #333333;
	font-size: 0.9375rem;
	text-decoration: none;
	margin-left: 0.5rem;
}

.lastHeader {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	font-size: 0.9375em;
	font-weight: 400;
	color: #666666;
	line-height: 28px;
	margin-left: 1rem;
}

.lastHeader li a {
	text-decoration: none;
	font-size: 0.9375rm;
	font-weight: 400;
	color: #222222;
	line-height: 28px;
}

.lastHeader li {
	list-style: none;
}

.footerBoxHeader {
	width: 60%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin-top: 1rem;
}

.footerBoxHeaderLeft,
.footerBoxHeaderRight {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-direction: column;
	flex-direction: column;
	-ms-flex-align: center;
	align-items: center;
}

.codeImg {
	width: 100%;
}

.codeText {
	font-size: 0.88em;
	font-weight: 400;
	color: #666666;
	line-height: 20px;
	/* margin-top: 0em; */
}


.footerInfoBox {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 1rem;
}

.emailBox {
	font-size: 0.875rem;

	font-weight: 400;
	color: #222222;
	line-height: 20px;
}


.phoneBox {
	font-size: 0.875rem;

	font-weight: 400;
	color: #222222;
	line-height: 20px;
	margin-top: 0.5rem;
}

.addressBox {
	font-size: 0.875rem;
	font-weight: 400;
	color: #222222;
	line-height: 20px;
	margin-top: 0.5rem;
	text-align: center;
}

.footerLine {
	width: 100%;
	height: 1px;
	display: flex;
	background: #000000;
	opacity: 0.1;
	margin: 0 auto;
	align-items: center;
	margin-top: 0.5rem;
}

.footerBoxBottom {
	display: flex;
	margin: 0 auto;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	margin-top: 1rem;
}

.footerLeft {
	text-align: center;
	font-size: 0.9em;
	font-weight: 400;
	color: #666666;
	line-height: 24px;
}

.footerLeft a {
	text-decoration: none;
	cursor: pointer;
	color: #666666;
}
</style>



// WEBPACK FOOTER //
// src/components/mComponents/mdynamicIntroduce.vue